module.exports = __webpack_public_path__ + "pc/img/02_img_01.275a25f5.png";